import axios from "axios"
import API_URLS from "../../config/global_variables";
import common_api from "../../config/common_api";
import common_mapping from "../../config/common_mapping";
const userData = localStorage.userData?JSON.parse(localStorage.userData):"";

const apidata = async () => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_ALL_SIMPLE_PRODUCTS,
      headers: {
        'Content-Type': 'application/json', 'Authorization': userData.token
      },
      data: JSON.stringify({ is_simple: true })
    };

    let data = await axios.request(config)
    if (data.status === 200) {
      let mappedData = await common_mapping.map_simplelist(data.data.data);
      return mappedData
    }
    return [];

  } catch (error) {
    console.error("error", error);

    return [];
  }
}

const get_stores = async () => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_STORES,
      headers: {
        'Content-Type': 'application/json', 'Authorization': userData.token
      },
    };

    let data = await axios.request(config)
    if (data.status === 200) {
      const mappedData = data.data.data.map((item, index) => {
        let properties = JSON.parse(item.properties)
        return {
          value: properties.key,
          label: properties.key
        }
      })
      return mappedData
    }
    return [];

  } catch (error) {
    return [];
  }
}

const active_inactive_status = async (reqdata = {}, status) => {
  try {
    if (reqdata && (reqdata.prdouct_data || reqdata.variant_data)) {
      let objdata = {}
      if (reqdata.prdouct_data) {
        objdata = {
          "store": reqdata.store,
          "product_id": reqdata.prdouct_data.product_id,
          "status": status,
          "is_variant": false
        }
      } else if (reqdata.variant_data) {
        objdata = {
          "store": reqdata.store,
          "product_id": reqdata.variant_data.product_id,
          "status": status,
          "is_variant": true,
          "variant_id": reqdata.variant_data.variant_id
        }
      } else {
        return false
      }
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: API_URLS.UPDATE_BC_PRODUCT_STATUS,
        headers: {
          'Content-Type': 'application/json', 'Authorization': userData.token
        },
        data: JSON.stringify(objdata)
      };

      let data = await axios.request(config)
      if (data.status === 200 && !data.data.error) {
        let responsedata = await data.data.refreshed_data;
        let finaldataafterupdte = await common_api.mapped_all(responsedata)
        return {
          type: 'success',
          title: 'Success!',
          message: data.data.message,
          data: finaldataafterupdte
        };
      }
      if (data.status === 200 && data.data.error) {
        return {
          type: 'error',
          title: 'Error!',
          message: data.data.error,
        };
      }
    } else {
       return {
        type: 'error',
        title: 'Error!',
        message: "data not found",
      }
    }

  } catch (error) {
     return {
      type: 'error',
      title: 'Error!',
      message: error.message,
    }
  }
}


const apiHelpers = {
  apidata,
  get_stores,
  active_inactive_status
};

export default apiHelpers;